import { redirect } from 'react-router-dom'
import { getPostSignInPath } from '../helpers/getPostSignInPath'
import { signInWithPassword } from '../helpers/supabase'

export interface SignInActionData {
  error: SignInActionError | null
}

export interface SignInActionError {
  code: string | undefined
  message: string
}

export default async function signInAction({
  request,
}: {
  request: Request
}): Promise<SignInActionData | Response> {
  const formData = await request.formData()
  const email = formData.get('email') as string
  const password = formData.get('password') as string

  const { data, error } = await signInWithPassword({
    email,
    password,
  })

  if (error) {
    return { error: { code: error.code, message: error.message } }
  }

  const url = new URL(request.url)
  const pathFromQuery = url.searchParams.get('path')
  const path = await getPostSignInPath({
    pathFromQuery,
    userId: data?.user?.id,
  })

  return redirect(path)
}
